import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css']
})
export class FaqsComponent implements OnInit {
  nao = new Nanobar();
  faqsData: any;
  faqsDeleteData: any;
  faqsAddData: any;
  faqsId: any;
  loadindData = true;
  paginatedDataFaqs: any;
  faqsPageCount = 0;
  faqsLastPage = true;
  deleteBtndDisable = false;
  type = 3;
  limit = 25;
  status = 0;
  editFaqs = false;
  question = '';
  answer = '';
  disableBtn = false;
  options: any;
  constructor(private dataService: DataService, private router: Router) {
    this.options = {
      onUpdate: (event: any) => {
        console.log('in drag function');
        this.updateFaqsSorting();
      }
    };
  }
  updateFaqsSorting(){
    this.dataService.setFaqsSorting(window.localStorage.getItem('token'), this.faqsData).subscribe(
      (data) => {
      },
      (error) => {
      }
    );
  }
  getFaqs() {
    this.loadindData = true;
    this.nao.go(30);
    this.dataService.getFaqslisting(window.localStorage.getItem('token'), this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.faqsData = data;
        this.faqsLastPage = this.faqsData.last_page;
        this.faqsPageCount++;
        this.faqsData = this.faqsData.items;

        this.loadindData = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getFaqslistingByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getFaqslistingByPage(window.localStorage.getItem('token'), this.faqsPageCount, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataFaqs = data;
        this.faqsLastPage = this.paginatedDataFaqs.last_page;
        this.faqsPageCount++;
        this.paginatedDataFaqs = this.paginatedDataFaqs.items;
        for ( var i = 0; i < this.paginatedDataFaqs.length; i++) {
          this.faqsData.push(this.paginatedDataFaqs[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  callFaqsFun(){
    this.editFaqs = false;
    this.disableBtn = false;
    this.question = '';
    this.answer = '';
    $('#FaqsPopup').modal('show');
  }
  openEditFaqsddFun(data){
    this.editFaqs = true;
    this.disableBtn = false;
    this.faqsId = data.id;
    this.question = data.question;
    this.answer = data.answer;
    $('#FaqsPopup').modal('show');
  }
  addFaqsddFun(){
    if ( this.question === '' ) {
      toastr.error('Please add question');
      return;
    }
    if ( this.answer === '' ) {
      toastr.error('Please add answer');
      return;
    }
    this.disableBtn = true;
    this.nao.go(30);
    this.dataService.addFaqs(window.localStorage.getItem('token'), this.question, this.answer).subscribe(
      (data) => {
        this.nao.go(100);
        this.faqsAddData = data;
        this.disableBtn = false;
        if ( this.faqsAddData.success === true ) {
          this.getFaqs();
          $('#FaqsPopup').modal('hide');
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  editFaqsddFun(){
    if ( this.question === '' ) {
      toastr.error('Please add faqs');
      return;
    }
    if ( this.answer === '' ) {
      toastr.error('Please add faqs');
      return;
    }
    this.disableBtn = true;
    this.nao.go(30);
    this.dataService.editFaqs(window.localStorage.getItem('token'), this.question, this.answer, this.faqsId).subscribe(
      (data) => {
        this.nao.go(100);
        this.faqsAddData = data;
        this.disableBtn = false;
        if ( this.faqsAddData.success === true ) {
          this.getFaqs();
          $('#FaqsPopup').modal('hide');
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  openDeleteFaqsPopup(data) {
    this.faqsId = data.id;
    $('#deleteFaqsPopup').modal('show');
  }
  deleteConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.deleteFaqs(window.localStorage.getItem('token'), this.faqsId).subscribe(
      (data) => {
        this.nao.go(100);
        this.faqsDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.faqsDeleteData.success === true ) {
          this.getFaqs();
          $('#deleteFaqsPopup').modal('hide');
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  
  
  ngOnInit() {
    this.getFaqs();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#faqs').css('color', '#d77229');
  }

}




// WEBPACK FOOTER //
// ./src/app/faqs/faqs.component.ts